<template>
	<div class="MAM_queryList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="queryForm" class="demo-form-inline">
				<el-form-item>
					<el-input size clearable v-model="queryForm.merchant_number" placeholder="请输入商户编号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="queryForm.terminal_sn" placeholder="请输入终端SN"></el-input>
				</el-form-item>
				<el-form-item>
					<el-select size v-model="queryForm.status" clearable placeholder="请选择当前状态">
						<el-option label="未审核" value="0"></el-option>
						<el-option label="提现审核通过" value="4"></el-option>
					    <el-option label="等待结果" value="3"></el-option>
				        <el-option label="审核拒绝" value="2"></el-option>
						 <el-option label="出款成功" value="1"></el-option>
						 <el-option label="出款失败" value="6"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-date-picker
					    v-model="rangeDate"
					    type="daterange"
					    range-separator="至"
					    start-placeholder="提现开始日期"
					    end-placeholder="提现结束日期"
					    value-format="yyyy-MM-dd"
					    @change="pickerChange"
					></el-date-picker>
				</el-form-item>
				
				<el-form-item>
					<el-date-picker
					    v-model="rangeDate2"
					    type="daterange"
					    range-separator="至"
					    start-placeholder="审核开始日期"
					    end-placeholder="审核结束日期"
					    value-format="yyyy-MM-dd"
					    @change="pickerChange2"
					></el-date-picker>
				</el-form-item>

				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(queryForm)">查询</el-button>
						<el-button style="font-size: 12px;margin-left:20px" size="small" type="primary" 
					 @click="morePay()">批量出款</el-button>
				<el-button style="font-size: 12px;margin-left:20px" size="small" type="primary" icon="el-icon-download"
					:loading="downLoading" @click="handleDownLoad(queryForm)">导出数据</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<div style="margin-bottom:20px;display: flex;">
				<div class="tableTitle">
			        <span>云账户余额：</span>
			        <span>{{total_balance}}</span>
			    </div>
				<div class="tableTitle"  style="margin-left: 50px;">
				    <span>到账总额：</span>
				    <span>{{sum}}</span>
				</div>
				
			</div>
			<el-table @selection-change="handleSelectionChange" :data="stockTable.list" size="mini" border style="width: 100%" v-loading="loading">
				<el-table-column :selectable="selectableFun" header-align="center"  align="center"  fixed type="selection" label="ID" min-width="80"></el-table-column>
				<el-table-column  min-width="150" header-align="center" align="center" prop="merchant_name" label="商户名称"></el-table-column>
				<el-table-column  min-width="150"  header-align="center" align="center" prop="merchant_number" label="商户编号"></el-table-column>
				<el-table-column  min-width="150" header-align="center" align="center" prop="terminal_sn" label="终端SN"></el-table-column>
				<el-table-column  min-width="140" header-align="center" align="center" prop="account_name" label="收款账户"></el-table-column>
				<el-table-column  min-width="100" header-align="center" align="center" prop="bank_code" label="收款银行账号"></el-table-column>
				<el-table-column  min-width="100" header-align="center" align="center" prop="id_card" label="身份证号"></el-table-column>
				<el-table-column min-width="140"  header-align="center" align="center" prop="money" label="提现金额(元)"></el-table-column>
				<el-table-column min-width="140"  header-align="center" align="center" prop="fee_money" label="代收税点(元)"></el-table-column>
				<el-table-column min-width="140"  header-align="center" align="center" prop="service_fee" label="出款服务费(元)"></el-table-column>
				<el-table-column min-width="140"  header-align="center" align="center" prop="true_money" label="实际到账(元)"></el-table-column>
				<el-table-column  min-width="100" header-align="center" align="center" prop="status_text" label="审核状态"></el-table-column>
				<el-table-column  min-width="150" header-align="center" align="center" prop="create_time" label="申请日期"></el-table-column>
				<el-table-column  min-width="150" header-align="center" align="center" prop="audit_time" label="审核日期"></el-table-column>
				<el-table-column  min-width="150" header-align="center" align="center" prop="remark" label="备注"></el-table-column>
				<el-table-column min-width="100"  header-align="center" align="center" fixed="right" label="操作"  >
					<template v-if="scope.row.status == 0" slot-scope="scope">
						<el-button @click="shenClick(scope.row)" type="text" size="small">审核</el-button>
					</template>
				</el-table-column>
				
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize"></paginations>
		</el-card>
		
		<el-dialog width="30%" title="批量审核并出款" :visible.sync="morePayState" class="dialog">
			<span style="margin-bottom: 10px;">确定要批量出款已勾选的提现记录吗？</span>
            <el-form   size="mini" v-if="pay_channel == 3">
               <el-form-item  style="display: flex; align-items: center;justify-content: flex-start;padding: 0px;color: #000;margin-top: 10px;" label="选择签约服务商：">
               	  <el-select @change="selChange"  v-model="service_company_id" clearable>
               	  	<el-option v-for="item in channelList" :label="item.service_company_name" :value="item.service_company_id"
               	  		:key="item.service_company_id"></el-option>
               	  </el-select>
               </el-form-item>                
               
             </el-form>

			<div slot="footer" class="dialog-footer">
			    <el-button :loading="downLoading"   type="primary"  @click="chuPayClick">全部通过并出款</el-button>
			    <el-button   @click="morePayState = false">取 消</el-button>
			</div>
		  
		</el-dialog>
		
		<el-dialog width="40%" title="审核并出款" :visible.sync="onePayState" class="dialog">
			<div class='dialogDes'>商户名称:{{oneShenItem.merchant_name}}</div>
			<div class='dialogDes'>商户编号：{{oneShenItem.merchant_number}}</div>
			<div class='dialogDes'>终端SN：{{oneShenItem.terminal_sn}}</div>
			<div class='dialogDes'>收款账户：{{oneShenItem.account_name}}</div>
			<div class='dialogDes'>收款银行账号：{{oneShenItem.bank_code}}</div>
			<div class='dialogDes'>身份证号：{{oneShenItem.id_card}}</div>
			<div class='dialogDes'>提现金额：{{oneShenItem.money}}</div>
			<div class='dialogDes'>代收税点：{{oneShenItem.fee_money}}</div>
			<div class='dialogDes'>出款服务费：{{oneShenItem.service_fee}}</div>
			<div class='dialogDes'>实际到账：{{oneShenItem.true_money}}</div>
			<div class='dialogDes'>申请日期：{{oneShenItem.create_time}}</div>
            <el-form   size="mini" v-if="pay_channel == 3">
               <el-form-item  style="display: flex; align-items: center;justify-content: flex-start;padding: 0px;color: #000;" label="选择签约服务商：">
               	  <el-select @change="selChange"  v-model="service_company_id" clearable>
               	  	<el-option v-for="item in channelList" :label="item.service_company_name" :value="item.service_company_id"
               	  		:key="item.service_company_id"></el-option>
               	  </el-select>
               </el-form-item>                
   
             </el-form>
			<div slot="footer" class="dialog-footer">
			    <el-button :loading="downLoading"   type="primary"  @click="chuPayClick">通过并出款</el-button>
			    <el-button   @click="shibaiState = true">驳 回</el-button>
			</div>
		</el-dialog>
		
		<el-dialog width="40%" title="请填写驳回原因" :visible.sync="shibaiState" class="dialog">
			<el-input
			  clearable
			  type="textarea"
			  :rows="3"
			  placeholder="请输入内容"
			  :maxlength="30"
			  v-model="textarea">
			</el-input>
			<div slot="footer" class="dialog-footer">
			    <el-button  type="primary"  @click="trueBohuiClick">确定</el-button>
			    <el-button   @click="shibaiState = false">取 消</el-button>
			</div>
		</el-dialog>
		

	</div>
</template>

<script>
	import paginations from '../../../components/pagination/paginations';
	export default {
		name: "teamMoneyShenList",
		data() {
			return {
				queryForm: {
					start_time:'',
					end_time:'',
					audit_start_time:'',
					audit_end_time:'',
					merchant_number:'',
					terminal_sn:'',
					status:'' 
				},
				stockTable: { //列表
					list: [],
				},
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 0 //总数
				},
				loading: true,
				downLoading: false, //导出loading
				morePayState:false,
				onePayState:false,
				shibaiState:false,
				textarea:'',
				oneShenItem:{},
				multipleSelection:[],
				rangeDate: '',
				rangeDate2: '',
				total_balance:0,//云账户余额
				sum:0,
                service_company_id:'',
                contract_code:'',
                channelList:[],
                pay_channel:1
			}
		},
		mounted() {
			this.handleDefaultTime();
			this.getData({
				page: this.page.currentPage,
				limit: this.page.pageSize
			})
            this.$api.post('user/withdraw_list', {}, res => {
                if (res.code == 0) {
                   this.channelList = res.data.contract_list
                    this.pay_channel =  res.data.pay_channel
                } else {
                    this.$message.error(res.msg);
                 
                }
            });
		},
		components: {
			paginations,
		},
		methods: {
            selChange(e) {
            for (let item of this.channelList) {
                if (item.service_company_id == e) {
                    this.contract_code = item.contract_code
                }
            }
          },

			//云账户余额
			yzh() {
				this.$api.post("yzh/get_account",{},res => {
					if (res.code == 0) {
						let data = res.data;
						this.total_balance = data.total_balance; 
					}
				})
			},
			pickerChange(DateArr) { //日期选择器
			    this.queryForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
			    this.queryForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},
			pickerChange2(DateArr) { //日期选择器
			    this.queryForm.audit_start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
			    this.queryForm.audit_end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},
			handleDefaultTime() { //默认获取三十天
			    // let date =this.$moment().endOf('day').format('x');
			    // this.queryForm.end_time = this.$moment(Number(date) - 3600 * 1000 * 24 -1).format("YYYY-MM-DD");
			    // this.queryForm.start_time = this.$moment(Number(date) - 3600 * 1000 * 24 * 31 +1).format("YYYY-MM-DD");
			},
			handleSelectionChange(rows){
				this.multipleSelection = rows;
			},
			selectableFun(item,index){
				if (item.status == 0) {
					return true
				}else {
					return false
				}
			},
			// 单调审核
			shenClick(item){
				this.oneShenItem = item
				this.onePayState = true
			},
			trueBohuiClick(){
				
				if (this.textarea.length == 0) {
					this.$message({
					    message: '请输入驳回原因'
					});
					return;
				}
				
				let params = {
					ids:this.oneShenItem.id,
					type:'2',
					reject_reason:this.textarea
				}
				
				this.$api.post("merchant_transaction_cash_reward/withdrawAudit", params, res => {
					if (res.code == 0) {
						this.$message({
						    message: '驳回成功!',
							type:'success'
						});
					}else {
						this.$message({
						    message: res.msg
						});
					}
					this.shibaiState = false
					this.onePayState = false
					this.getPageSize(10);
				})
				
				
			},
			// 出款
			chuPayClick(){
                if (this.pay_channel == 3 && this.service_company_id.length == 0) {
                this.$message.error({
                    type: 'error',
                    message: '请选择签约服务商!',
                    duration: 2000,
                });
                return
                }
				let params = {
					type:1,
					reject_reason:'',
                    pay_channel:this.pay_channel, 
                    contract_code: this.contract_code,
                    service_company_id: this.service_company_id
				}
				if (this.onePayState == true) {
					params.ids = this.oneShenItem.id
				}else {
					let arr = []
					for (let item of this.multipleSelection) {
						arr.push(item.id)
					}
					params.ids = arr.join(',')
				}
                
                
               

				this.downLoading = true;
				this.$api.post("merchant_transaction_cash_reward/withdrawAudit", params, res => {
					if (res.code == 0) {
						this.$message({
						    message: '出款成功!',
							type:'success'
						});
					}else {
						this.$message({
						    message: res.msg
						});
					}
					this.downLoading = false;
					this.shibaiState = false
					this.onePayState = false
					this.morePayState = false
					this.getPageSize(10);
				})
				
			},
			morePay() {
				if (this.multipleSelection.length == 0) {
					this.$message({
					    message: '请先选择要批量出款的数据!'
					});
					return;
				}else {
					this.morePayState = true
				}
				
			},
			handleDownLoad(params) { //导出
				let reqData = {
					type: 36,
					value: JSON.stringify(params)
				};

				this.downLoading = true;
				this.$api.post('export/add', reqData, res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.downLoading = false;
					} else {
						this.$message.error(res.msg);
						this.downLoading = false;
					}

				})
			},
			onSearch(queryForm) {
				this.page.currentPage = 1;
				queryForm.page = this.page.currentPage;
				queryForm.limit = this.page.pageSize;
				// 表单提交
				this.getData(queryForm);
			},
			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.page.currentPage = page;
				this.loading = true;
				this.queryForm.page = page;
				this.queryForm.limit = this.page.pageSize;
				this.getData(this.queryForm);
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.page.pageSize = limit;
				this.loading = true;
				this.queryForm.page = this.page.currentPage;
				this.queryForm.limit = limit;
				this.getData(this.queryForm);
			},
			getData(params) {
				this.$api.post("merchant_transaction_cash_reward/withdrawList", params, res => {
					if (res.code == 0) {
						this.yzh();
						let data = res.data;
						this.page.total = data.count; //总数
						this.stockTable.list = data.list;
						this.sum = data.sum;//到账总额
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false;
				})
			}
		}
	};
</script>

<style lang="scss" scope>
	.MAM_queryList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}
	.dialogDes {
		height: 30px;
		line-height: 30px;
	}
</style>